module.exports = __webpack_public_path__ + "media/3-11.6d2b6832.wav";